export const COMPONENTS_TYPE = {
    listObjBylvl : 'list-vcfs-by-lvl',
    listSubObjs : 'list-by-sub-vcfs' 
}